import { UserInterface } from '../interfaces/user';

export function setItem(key: string, value: string): void {
  localStorage.setItem(`${key}`, value);
}

export function getItem(key: string): string | null {
  return localStorage.getItem(`${key}`);
}

export function removeItem(key: string): void {
  localStorage.removeItem(`${key}`);
}

export const getUserData = (): {
  user: UserInterface | null;
  token: string | null;
} => {
  const token: string | null = getItem('token');
  const user: string | null = getItem('user');

  return {
    user: JSON.parse(String(user)),
    token,
  };
};

export const setUserData = (user: UserInterface, token: string): void => {
  /*
   * IMPORTANTE: não alterar as keys salvas no localStorage para não impactar
   * módulos que utilizam estes items
   */
  setItem(
    'user',
    JSON.stringify({
      ...user,
      token,
    }),
  );
  setItem('token', token);
};

export const clearUserData = (): void => {
  removeItem('token');
  removeItem('user');
};
